export default __webpack_public_path__ + "static/media/heart.0d220540.svg";